import React, { useState, useEffect, Fragment } from "react";
import {
  TabPane,
  Card,
  Button,
  CardText,
  Row,
  Col,
  Label,
  Input,
  CustomInput,
  CardBody,
} from "reactstrap";
import "./index.css";
import ApiCaller from "../../../../api/apiCaller";
import Image from "../Image";
import PhotoInstruction from "../PhotoInstruction";
import Lightbox from "react-image-lightbox";
import t from "utils/Lang";

interface LegalDocumentTapProps {
  isView: boolean;
  siteData: any;
  setSiteData: Function;
  selectedPhotos: any;
  setSelectedPhotos: Function;
  onImageRemoved?: Function;
  onExistingAttachmentsUpdated?: Function;
}

export default function LegalDocumentTab({
  isView,
  siteData,
  setSiteData,
  selectedPhotos,
  setSelectedPhotos,
  onImageRemoved,
  onExistingAttachmentsUpdated,
}: LegalDocumentTapProps) {
  const randomString = Math.random().toString(36).substring(7);
  const fileInputId = `${Date.now().toString()}-${randomString}`;

  const [showPhotoInstruction, setShowPhotoInstruction] =
    useState<boolean>(false);
  const [attachmentToUploads, setAttachmentToUploads] =
    useState<Array<any> | null>([]);

  const [imageBoxState, setImageBoxState] = useState({
    showLightBox: false,
    photoIndex: 0,
  });

  const updateAttachmentToUpload = (attachmentToUpdate: any) => {
    const newAttachmentToUpload = attachmentToUploads;
    newAttachmentToUpload?.forEach((attachment: any, index: number) => {
      if (attachment.url === attachmentToUpdate.url) {
        newAttachmentToUpload[index] = attachmentToUpdate;
      }
    });

    setAttachmentToUploads(attachmentToUploads);
    setSelectedPhotos(attachmentToUploads);
  };
  const deleteAttachmentToUpload = (url: string) => {
    if (attachmentToUploads) {
      setAttachmentToUploads(
        attachmentToUploads.filter((attachment) => attachment.url != url)
      );
    }
  };

  const updateExistingAttachment = (attachmentToUpdate: any) => {
    const existingAttachments = siteData.data.attachments;
    existingAttachments?.forEach((attachment: any, index: number) => {
      if (attachment.id === attachmentToUpdate.id) {
        existingAttachments[index] = attachmentToUpdate;
      }
    });
    if (onExistingAttachmentsUpdated) {
      onExistingAttachmentsUpdated(existingAttachments);
    }
  };
  const deleteExistingAttachment = async (attachmentToDelete: any) => {
    const confirmationBox = window.confirm(t().site_photo_tab__delete_photo);
    if (!confirmationBox) return;
    const uri = `file_attachment/${attachmentToDelete.id}/delete`;
    const res = await ApiCaller.delete(uri);
    if (res.status === "ok") {
      const currentSiteData = siteData;
      setSiteData({
        ...currentSiteData,
        data: {
          ...currentSiteData.data,
          attachments: currentSiteData.data.attachments.filter(
            (attachment: any) => attachment.id != attachmentToDelete.id
          ),
        },
      });
    } else {
      alert(res.msg);
    }
  };

  const attachFileButtonClick = () => {
    if (document.getElementById(fileInputId)) {
      document?.getElementById(fileInputId)?.click();
    }
  };

  const photoInstructionClick = () => {
    setShowPhotoInstruction(!showPhotoInstruction);
  };

  const selectImagesToUpload = (event: any) => {
    const filesArray = Array.from<any>(event.target.files);
    const newAttachmentToUploads = filesArray.map((file) => {
      return {
        blob: file,
        url: URL.createObjectURL(file),
      };
    });
    let attachmentData = [];
    if (attachmentToUploads) {
      attachmentData = [...attachmentToUploads, ...newAttachmentToUploads];
    } else {
      attachmentData = [...newAttachmentToUploads];
    }
    setAttachmentToUploads(attachmentData);
    setSelectedPhotos(attachmentData);
  };

  const onImageClick = (imageUrl: any, imageArray: any) => {
    imageArray.map((url: string, idx: any) => {
      if (url === imageUrl) {
        setImageBoxState({
          showLightBox: true,
          photoIndex: idx,
        });
      }
    });
  };

  useEffect(() => {}, []);

  let images: any = [];
  let imageTitles: any = [];
  let imageCaptions: any = [];
  if (siteData?.data?.attachments) {
    const imageArray = siteData?.data?.attachments?.filter(
      (attachment: any) => attachment.file_type === "image"
    );
    images = imageArray.map((attachment: any) => attachment.file_url);
    imageTitles = imageArray.map((attachment: any) => attachment.file_name);
    imageCaptions = imageArray.map(
      (attachment: any) => attachment.caption_text
    );
  }
  return (
    <TabPane tabId="image_tab">
      <Row>
        {!isView && (
          <Col xs={12} sm={6}>
            <div style={styles.actionSheet}>
              <Button
                outline
                color="primary"
                onClick={attachFileButtonClick}
                style={styles.commentButton}
              >
                <i className="material-icons">insert_photo</i>
                <span>{t().site_photo_tab__insert_photo}</span>
              </Button>
              <Input
                accept="image/*,video/*"
                type="file"
                label={t().site_photo_tab__select_file}
                title=""
                id={fileInputId}
                multiple
                hidden
                style={styles.selectFileButton}
                onChange={(e) => selectImagesToUpload(e)}
                key={fileInputId}
              />
            </div>
          </Col>
        )}
        <Col xs={12} sm={6}>
          <div style={styles.actionSheet}>
            <Button
              outline
              color="primary"
              onClick={photoInstructionClick}
              style={styles.commentButton}
            >
              <i className="material-icons">note</i>
              <span>{t().site_photo_tab__photo_guide_line}</span>
            </Button>
          </div>
        </Col>
      </Row>
      <Row style={styles.attachmentContainer}>
        {attachmentToUploads && attachmentToUploads.length > 0 && (
          <Fragment>
            {attachmentToUploads.map((attachment, index) => (
              <Col xs={12} sm={6} key={index}>
                <div style={styles.attachmentWrapper}>
                  <Image
                    key={`attachment-index-${index}`}
                    isView={isView}
                    attachment={attachment}
                    onAttachmentToUploadDeleted={(attachment: any) =>
                      deleteAttachmentToUpload(attachment.url)
                    }
                    onAttachmentUpdated={(attachmentAfterUpdated: any) =>
                      updateAttachmentToUpload(attachmentAfterUpdated)
                    }
                  />
                </div>
              </Col>
            ))}
          </Fragment>
        )}
        {siteData?.data?.attachments?.map((attachment: any) => {
          // Do not show legal document files on this tab
          if (attachment.attachment_content_relation_type === "legal_document")
            return null;
          return (
            <Col xs={12} sm={6} key={`${attachment.id}`}>
              <div style={styles.attachmentWrapper}>
                <Image
                  isView={isView}
                  attachment={attachment}
                  isExistingAttachment
                  onAttachmentUpdated={(attachmentAfterUpdated: any) =>
                    updateExistingAttachment(attachmentAfterUpdated)
                  }
                  onExistingAttachmentDeleted={(attachment: any) =>
                    deleteExistingAttachment(attachment)
                  }
                  onImageClick={(attachment: any) =>
                    onImageClick(attachment.file_url, images)
                  }
                />
              </div>
            </Col>
          );
        })}
      </Row>
      {imageBoxState?.showLightBox && (
        <Lightbox
          mainSrc={images[imageBoxState?.photoIndex]}
          nextSrc={images[(imageBoxState?.photoIndex + 1) % images.length]}
          prevSrc={
            images[
              (imageBoxState?.photoIndex + images.length - 1) % images.length
            ]
          }
          onCloseRequest={() =>
            setImageBoxState({ ...imageBoxState, ...{ showLightBox: false } })
          }
          onMovePrevRequest={() =>
            setImageBoxState({
              ...imageBoxState,
              ...{
                photoIndex:
                  (imageBoxState?.photoIndex + images.length - 1) %
                  images.length,
              },
            })
          }
          onMoveNextRequest={() =>
            setImageBoxState({
              ...imageBoxState,
              ...{
                photoIndex: (imageBoxState?.photoIndex + 1) % images.length,
              },
            })
          }
          imageTitle={imageTitles[imageBoxState?.photoIndex]}
          imageCaption={imageCaptions[imageBoxState?.photoIndex]}
        />
      )}
      {showPhotoInstruction && (
        <PhotoInstruction
          isShow={showPhotoInstruction}
          toggleFunction={photoInstructionClick}
        />
      )}
    </TabPane>
  );
}

const styles = {
  customTextInput: {
    marginTop: 20,
  },
  imageContainer: {},
  imageNote: {
    marginTop: 12,
  },
  commentButtonContainer: {
    backgroundColor: "var(--color-line-light)",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 6,
    paddingRight: 3,
    paddingBottom: 3,
  } as React.CSSProperties,
  commentButton: {
    marginLeft: 6,
  },
  selectFileButton: {},
  imageAttachment: {
    width: 180,
    height: 180,
    borderRadius: 6,
    marginRight: 12,
    marginBottom: 12,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    position: "relative",
    backgroundColor: "var(--color-line)",
    border: "1px solid var(--color-line)",
  } as React.CSSProperties,
  imageAttachmentDeleteButton: {
    fontSize: 12,
    width: 20,
    height: 20,
    borderRadius: "50%",
    border: "none",
    backgroundColor: "var(--color-muted)",
    color: "var(--color-white)",
    position: "absolute",
    top: 4,
    right: 4,
  } as React.CSSProperties,
  generalFileAttachmentDeleteButton: {
    fontSize: 12,
    width: 20,
    height: 20,
    borderRadius: "50%",
    border: "none",
    backgroundColor: "var(--color-muted)",
    color: "var(--color-white)",
    marginLeft: 16,
  },
  fileAttachment: {
    marginRight: 12,
    fontSize: 12,
    fontWeight: 500,
    borderRadius: 3,
    padding: "6px 12px",
    backgroundColor: "var(--color-line)",
  },
  actionSheet: {
    marginTop: 24,
    marginBottom: 24,
  },
  attachmentContainer: {
    marginBottom: 48,
    marginTop: 24,
  },
  attachmentWrapper: {
    marginBottom: 24,
  },
};
